import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import style from 'style';
import Divider from '../../../../components/Divider';


const Container = styled.div`
  border: 1px solid ${style.colors.lightBorder};
  padding: 25px 40px;
  border-radius: 30px;
  box-shadow: ${style.shadow(15)};
  background: white;
  flex-shrink: 3;

  .title {
    font-size: 32px;
    font-weight: 700;
    color: black;
  }

  .subtitle {
    font-weight: 500;
    font-size: 16px;
    margin-top: 5px;
    margin-bottom: 20px;
    color: black;
  }

  .number {
    color: ${style.colors.secondary};
    font-size: 18px;
    font-weight: 700;
    line-height: 16px;
  }

  font-size: 14px;
  color: #7d7d7d;
`;

const HowItWorksCard = ({ name, providerCount, trackingPage, ...props }) => {

  const submissionPageContent = () => (
    <>
      <div className="title">
        We can start matching now, <span style={{color: style.colors.secondary}}>{name}</span>
      </div>
      <div className="subtitle">
        But we have a few more <span style={{color: style.colors.palette.textGrey}}><i>optional</i></span> questions that help
      </div>
      <div>
        We understand the complexities of finding a new provider, these extra questions
        will help with matching you with the perfect one and avoid any frustrations.
        <br /><br />We will contact the <span className="number">{providerCount}</span> providers
        you found and then present up to <span
          className="number">{providerCount < 3 ? providerCount : 3}</span> options.
        You make the final decision.
      </div>
      <>
        <Divider name="Important" style={{margin: '12px 0'}}/>
        <div>
          Please hit the <span style={{color: style.colors.secondary}}><b>Save</b></span> button
          after completing any additional questions to see the results.
        </div>
      </>
    </>
  );

  const trackingPageContent = () => (
    <>
      <div className="title">
        You can relax now, <span style={{color: style.colors.secondary}}>{name}</span>
      </div>
      <div className="subtitle">
        We understand that finding the right provider can be time-consuming and frustrating. Let us handle the
        legwork for you.
      </div>
      <div>
        Instead of you contacting the <span className="number">{providerCount}</span> providers
        you found, our system will confirm their ability to meet your needs and availability. Meanwhile, you can
        relax. We&apos;ll then present up to <span className="number">{providerCount < 3 ? providerCount : 3}</span> suitable
        providers, and you make the final
        decision.
      </div>
    </>
  );

  return (
    <Container {...props}>
      {trackingPage ? trackingPageContent() : submissionPageContent()}
    </Container>
  );
};

HowItWorksCard.propTypes = {
  name: PropTypes.string,
  providerCount: PropTypes.number,
  trackingPage: PropTypes.bool,
};


export default HowItWorksCard;

